/* Electric Wheels — related designs (brief §6.6)
   Narrow to the visitor's stored fitment; fall back to whatever this
   product itself fits. This block is the destination for every
   "doesn't fit" link, so it must never render empty. */
(function () {
  var root = document.querySelector('[data-ew-related]');
  if (!root) return;

  var F = window.EWFitment;
  var grid  = root.querySelector('[data-ew-related-grid]');
  var note  = root.querySelector('[data-ew-related-note]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ew-card]'));
  if (!cards.length) return;

  var pdp = document.querySelector('[data-ew-pdp]');
  var own = pdp ? (pdp.getAttribute('data-fits') || '').split(' ').filter(Boolean) : [];

  cards.forEach(function (c) {
    c._fits = (c.getAttribute('data-fits') || '').split(' ').filter(Boolean);
  });

  function apply(id) {
    var target = id ? [id] : own;
    var match = cards.filter(function (c) {
      return target.some(function (t) { return c._fits.indexOf(t) > -1; });
    });
    /* never leave the row empty — show everything rather than nothing */
    var show = match.length ? match : cards;

    cards.forEach(function (c) { c.classList.toggle('is-hidden', show.indexOf(c) < 0); });

    if (note) {
      if (id && match.length) {
        note.hidden = false;
        note.textContent = F.designs(match.length) + ' ' + F.verb(match.length) +
                           ' your ' + F.info(id).name + '.';
      } else if (id && !match.length) {
        note.hidden = false;
        note.textContent = 'Nothing else in the range is listed for your ' +
                           F.info(id).name + ' yet — here is everything we stock.';
      } else {
        note.hidden = true;
      }
    }
  }

  F.on(apply);
})();
